export default __webpack_public_path__ + "static/hello_jag_run-724759d1b12f7eacae44115b547d0c82.png";